module.exports = __webpack_public_path__ + "img/rest_icon.690db72e.png";